import React from "react";
import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";
import {Checkbox, FormControlLabel} from "@material-ui/core";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const ProcessMiningProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: any) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.currentTarget;
    const productCopy = { ...product };
    productCopy.properties = { ...productCopy.properties };
    productCopy.properties[name] = !productCopy.properties[name];
    onProductChange(productCopy);
  };

    const handleProfileChange = (newProfile: string) => {
      const productCopy = { ...product, profile: newProfile };
      onProductChange(productCopy);
    };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FormControlLabel
          control={
            <Checkbox
                checked={!!product.properties?.modelBasedApplications}
                onChange={handleCheckboxChange}
                disabled={!editable}
                name="modelBasedApplications"
            />
          }
          label="Model-based applications (Discover process model or Import BPMN model)"
      />
      <FlexSection>
        <DraftNumberInput
          label="Number of Events In Millions"
          product={product}
          field="eventsInMillions"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
        <DraftNumberInput
          label="Number of Case And Events Fields"
          product={product}
          field="caseAndEventFields"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default ProcessMiningProductWidget;
